/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Src_EpubInputs */

const en_funnel_src_epub = /** @type {(inputs: Funnel_Src_EpubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EPUB`)
};

const es_funnel_src_epub = /** @type {(inputs: Funnel_Src_EpubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EPUB`)
};

/**
* | output |
* | --- |
* | "EPUB" |
*
* @param {Funnel_Src_EpubInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_src_epub = /** @type {((inputs?: Funnel_Src_EpubInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Src_EpubInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_src_epub(inputs)
	return en_funnel_src_epub(inputs)
});